/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downloadlinksempty2Inputs */

const en_downloadlinksempty2 = /** @type {(inputs: Downloadlinksempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No links yet. Create the first one above.`)
};

const de_downloadlinksempty2 = /** @type {(inputs: Downloadlinksempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Links. Leg oben den ersten an.`)
};

/**
* | output |
* | --- |
* | "No links yet. Create the first one above." |
*
* @param {Downloadlinksempty2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const downloadlinksempty2 = /** @type {((inputs?: Downloadlinksempty2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloadlinksempty2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_downloadlinksempty2(inputs)
	return de_downloadlinksempty2(inputs)
});
export { downloadlinksempty2 as "downloadLinksEmpty" }